import Vue from 'vue'
import http from '@/fetch/http'
import * as types  from '@/vuex/types'
import util from '@/utils'

const state = {
  //试卷库列表
  paperList: [],
  //课程列表
  courseList: [],
  examType: '1', // 评测类型0测验1练习
  paperListPageNo: 1,             // 试题库列表页面当前页数
  paperListPageSize: types.SCROLL_LOADING.PAPER_LIST_PAGE_SIZE     // 试题库列表页面每页数量
}

const actions = {
  /**
   * 查询试卷库
   * @param commit
   * @param name
   */
  selectExercisePaper({commit}, param){
    let params = {
      paperName: param.name,
      pageNo: state.paperListPageNo,
      pageSize: state.paperListPageSize
    }
    http.selectExercisePaper(params).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        commit("SET_PAPER_LIST", res.data);
      }
    });
  },

  /**
   * 删除试卷
   * @param commit
   * @param param
   */
  deleteExercisePaper({commit}, params){
    let param = {
      paperId: params.id
    }
    http.deleteExercisePaper(param).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        params.success();
      }
    });
  },

  // 改变当前页数
  setPaperListPageNo({commit}, params){
    commit("SET_PAPER_LIST_PAGE_NO", params);
  },
  
  // 设置测评类型
  setExamType({commit}, params) {
	commit("SET_EXAM_TYPE", params);
  }
}

const getters = {}

const mutations = {
  ['SET_PAPER_LIST'](state, list) {
    Vue.set(state, 'paperList', list);
  },
  ['SET_COURSE_LIST'](state, list) {
    Vue.set(state, 'courseList', list);
  },
  ['SET_EXAM_TYPE'](state, examType) {
	Vue.set(state, 'examType', examType);
  },
  ['SET_PAPER_LIST_PAGE_NO'](state, params) {
    Vue.set(state, 'paperListPageNo', params);
  },
  ['SET_PAPER_LIST_PAGE_SIZE'](state, params) {
    Vue.set(state, 'paperListPageSize', params);
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/paperlibrary.js